/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_View_All_TimeInputs */

const vi_order_view_all_time = /** @type {(inputs: Order_View_All_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem toàn thời gian`)
};

/**

* @param {Order_View_All_TimeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_view_all_time = /** @type {((inputs?: Order_View_All_TimeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_View_All_TimeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_view_all_time(inputs)
});